import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'pf-field-display',
    standalone: true,
    templateUrl: './field-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
})
export class FieldDisplayComponent {
    @Input({ required: true }) label!: string;
    @Input({ required: true }) display!: string;


    get id(): string {
        const normalized =
            this.label.trim().replaceAll(/\s+/g, '-').toLowerCase() || 'value';
        return `fd-${normalized}`;
    }


    get valueId(): string {
        return `${this.id}-value`;
    }
}
